<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 mb-4 px-2">
      <h2 class="mb-2 text-center">Forgot your Password?</h2>
      Enter the cell phone or email you use to login to this acccount
      and we will send you a password reset code.

      <div class="mt-4 grey--text text--darken-1">
        <em>Tip: most Pros login with a cell phone</em>
      </div>
    </div>
    <v-form class="mt-1" ref="form" @submit.prevent="codeClick">
      <v-text-field 
        v-model="user_id"
        outlined dense hide-details="auto"
        persistent-placeholder
        validate-on-blur
        label="Cell Phone or Email"
        :rules="[required]"
        autocomplete="off" autocapitalize="none"
      />
      <div class="ml-3 mt-3 mb-5">
        <router-link :to="{ name: 'login' }" replace>
          Back to Login
        </router-link>
      </div>
      <div class="d-flex justify-center">
        <v-btn width="60%" type="submit" color="primary">Send Code</v-btn>
      </div>
    </v-form>
    <ErrorOverlay
      title="Error" v-model="error_dialog"
      :loading="loading" :message="error_message"
    />
  </div>
</template>
<script>

import { ErrorOverlay } from '@/components/pages'
import api from '@/lib/api'
import { mapMutations } from 'vuex'
import { required } from '@/lib/validations'

export default {
  name: 'Forgot',

  components: { ErrorOverlay },

  data() {
    return {
      user_id: '',

      // error handling
      loading: false,
      error_dialog: false,
      error_message: '',

      // validations
      required,
    }
  },

  methods: {
    ...mapMutations('auth', ['SET_UNVERIFIED_PRO']),

    async codeClick() {
      if (this.$refs.form.validate()) {
        const { user_id } = this

        this.loading = true
        const result = await api.insecure_post('/base/get_recovery_code', { user_id })
        this.loading = false

        if (result.ok) {
          this.SET_UNVERIFIED_PRO(user_id)
          this.$router.replace({ name: 'verify',  })
        } else if (result.status == 404) {
          this.error_dialog = true
          this.error_message = "No user found with that email/phone."
        }
      }
    },
  },
}
</script>
